/**
 * Copyright (C) 2021 - 2025 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { InputFieldComponent } from '../../../components/form/input-field/input-field.component';
import { NumberOfCharactersPipe } from '../../../pipes/number-of-characters/number-of-characters.pipe';
import { PipesModule } from '../../../pipes/pipes.module';
import { CharacterLimitComponent } from '../shared/character-limit/character-limit.component';

@NgModule({
	imports: [
		CommonModule,
		MatIconModule,
		CharacterLimitComponent,
		PipesModule,
		NumberOfCharactersPipe,
	],
	declarations: [InputFieldComponent],
	exports: [InputFieldComponent],
})
export class InputFieldModule {}
